export const baseList = [
    {
        name:'假日海滩沿线(及周边)',
        xyz:`110.236275,20.029589`,
        kw0:'长流镇',
        kw1:'林琪: 13322076071',
        kw2:'区城管局 纪小虎: 13519828855',
        kw3:`林雷（12时至18时）叶朝阳（18时至凌晨2时）`,
        kw4:`郑美珠: 13648641072`,
        kw5:`谭传声: 18689613663`,
        kw6:`谭义昭: 13807584594`,
        kw7:`李敏世: 18689567726 钟生彪: 13876029334`,
        kw8:`吉凯: 18976853811（民警）、杜朝清: 18976313368、杜治健: 15120668061`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时`,
        kw11:`由城管负责安排无人机全程监控`,
    },
    {
        name:'长彤路(及周边)',
        xyz:`110.224848,20.016348`,
        kw0:'长流镇',
        kw1:'林二星: 13907533691',
        kw2:'市生态环境局秀英分局 洪延华: 13379818088  ',
        kw3:`林雷（12时至18时）李辉（18时至凌晨2时）`,
        kw4:`韩旭光: 18907668669、王丁婷: 18078977354`,
        kw5:`吴古善: 18976767949`,
        kw6:`杜仕: 18976911308`,
        kw7:`谭传凯: 13976103073、陈丹: 18089869068`,
        kw8:`张小功（民警）13519843858、邝道罗: 13807659477 、张昭天: 18389878151`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时`,
        kw11:``,
    },
    {
        name:'长怡路、长天路(及周边',
        xyz:`110.246532,20.02167`,
        kw0:'长流镇',
        kw1:'李铭: 18889189366',
        kw2:'区住建局 蔡海: 13876262757',
        kw3:`林雷（12时至18时）叶朝阳（18时至凌晨2时）`,
        kw4:`郑美珠: 13648641072`,
        kw5:`张岗: 15607613720`,
        kw6:`吴育慧: 18889922558、王远旭: 17098258233`,
        kw7:`杜诗能: 18189885579、叶纯德: 13976095694`,
        kw8:`张小功（民警）13519843858、谭友平: 15203666573、黄彬: 13976648473`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时`,
        kw11:``,
    },
    {
        name:'市委市政府(及周边)',
        kw0:'长流镇',
        xyz:`110.199886,20.044215`,
        kw1:'孙京正: 13976899876',
        kw2:'区科工信 陈维坚: 13876194888 ',
        kw3:`林雷（12时至18时）、周礼来（18时至凌晨2时）`,
        kw4:`陈华: 15108992222王欣桂: 18976525577、李剑苗: 15109838586、黄朝忠: 13036023993`,
        kw5:`陈  毛: 18089769555`,
        kw6:`吴至就: 18976785711`,
        kw7:`吴乾霖: 13876934756、王禄华: 18889822062`,
        kw8:`吴青杨（民警）18689912833、伍人术: 15108995495 、李啟文: 18789541297`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时`,
        kw11:``,
    },
    {
        name:`永和、永秀花园（及周边）`,
        kw0:`长流镇`,
        xyz:`110.206827,19.997225`,
        kw1:`符师晓: 13198952001`,
        kw2:`区民政局 谢吉红: 18976726868`,
        kw3:`林雷（12时至18时）、蔡道力（18时至凌晨2时）`,
        kw4:`周婉君: 15120610011、赵琪: 13976015077`,
        kw5:`陈允清: 13907682011`,
        kw6:`陈允清: 13907682011`,
        kw7:`张光金: 13687502597 李经超: 13307507701`,
        kw8:`许德伟（民警）13976685345、李献清: 18976396599  、李德龙: 13876076146  、叶纯生: 18089706169`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时`,
        kw11:``,
    },
    {
        name:`琼华村(及周边)`	,
        kw0:`长流镇`,
        xyz:`110.23016,20.00852`,
        kw1:`周世郁: 15120852555`,
        kw2:`区司法局 谭新敦: 13687589915`,
        kw3:`林雷（12时至18时）李志文（18时至凌晨2时）`,
        kw4:`林玉娟: 18289377588陈敏: 15103663693邝道总: 15108968633	`,
        kw5:`谭朝经: 13078971313`,
        kw6:`谭朝经: 13078971313、陈希: 13518883267`,
        kw7:`吴正敏: 13005032503、陈希: 13518883267`,
        kw8:`张小功（民警）13519843858 、谭节仁: 15008083717 、钟士宝: 13876384238`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:`由长流镇负责安排无人机全程监控`				
    },
    {
        name:`永桂村（长滨路南段公庙和祠堂）`	,
        kw0:`长流镇`,
        xyz:`110.20896,19.999948`,
        kw1:`符怡: 18976657133`,
        kw2:`区水务局 陈亚明: 13617526744`,
        kw3:`林雷（12时至18时）郑心俊（18时至凌晨2时）`,
        kw4:`纪定才: 13398985321、王家浓: 13518822502、李红英: 13078930678、陈创川: 13337598088`,
        kw5:`吴友胜: 13322006938、吴爱钻: 13976686426`,
        kw6:`吴爱钻: 13976686426`,
        kw7:`谭义懂: 18889554505、吴礼援: 18203084729`,
        kw8:`许德伟（民警）13976685345、王绥宝: 13976107550、李道多:  13737661053`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``			
    },
    {
        name:`五源河湿地公园入海口(及周边)`	,
        kw0:`长流镇`,
        xyz:`110.209967,20.052356`,
        kw1:`周腾芳: 15203658885`,
        kw2:`区统计局 陈学军: 13807690699`,
        kw3:`黄奕标、张德杰: 13689888833`,
        kw4:`杜宏明: 13637581126`,
        kw5:`谭传声: 18689613663`,
        kw6:`谭传声: 18689613663`,
        kw7:`陆新奇: 18976301179、吴义玲: 18889764899`,
         kw8:`吴青杨（民警）18689912833`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``			
    },
    {
        name:`长影环球100(及周边)`	,
        kw0:`长流镇`,
         xyz:`110.192965,19.982832`,
        kw1:`王德凯: 15692580081`,
        kw2:`区发展和改革委员会 李国新: 13707513199`,
        kw3:` 黄奕标: 13876690220、伍卓章: 15248943678`,
        kw4:`黄宏明: 13876365336、杜喜喜: 136307630600`,
        kw5:`李道嘉: 13006097117`,
        kw6:`李道嘉: 13006097117`,
        kw7:`伍火安: 13876372697、李陈: 13876760337`,
        kw8:`毕胜珍（民警）18876085212`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``			
    },
     {
        name:`会展中心（及周边）`	,
        xyz:`110.194229,20.057402`,
        kw0:`长流镇`,
        kw1:`王大周: 18907595599`,
        kw2:`区教育局 李雄伟: 18876188686`,
        kw3:`张德杰: 13689888833`,
        kw4:`杜宏明: 13637581126`,
        kw5:`史良民: 15120967800`,
        kw6:`史良民: 15120967800`,
        kw7:`于凯: 13976861617、洪礼高: 15120939197`,
        kw8:`郑晶: 13976659180`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``			
    },
     {
        name:`书场村(及周边)`	,
        kw0:`秀英街道`,
         xyz:`110.282886,20.010288`,
        kw1:`王波: 15308913666`,
        kw2:`区环卫局 吴坤东: 13907568775`,
        kw3:`柯森林: 13111988261（1月31日21时-24时）林小瑜: 13337627577（2月1日凌晨0时-凌晨2时、早上6时至9时）杨德伟: 18789670203（2月15日19时至2月16日凌晨2时）`,
        kw4:`王阳英: 13006035757、文志刚: 15692591112（1月31日21时-24时）陈向芬: 13976658886唐劲18208945660（2月1日凌晨0时-凌晨2时、早上6时至9时）霍娟: 13707522019周经震13876699719（2月15日19时至2月16日凌晨2时）`,
        kw5:`黄启福: 13907580165、王孟: 13807591185、李恩德: 13876245913`,
        kw6:`吴名福: 17766996515、张莉: 13876738078、王瑞需: 18976656811`,
        kw7:`吴诗健: 13976922536（1月31日21时至凌晨2时、2月15日21时至2月16日凌晨2时）洪明庆: 13876038422（2月1日早上6时至9时）`,
        kw8:`蔡俊翔: 13599597330、林业昌: 18976355228`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``
					
    },
    {
        name:`海南省人民医院周边(美俗村)`	,
        xyz:`110.287732,20.004812`,
        kw0:`秀英街道`,
        kw1:`王颖: 17763815613`,
        kw2:`区卫健委 张维: 18907568000`,
        kw3:`柯森林: 13111988261（1月31日21时-24时）林小瑜: 13337627577（2月1日凌晨0时-凌晨2时、早上6时至9时）杨德伟: 18789670203（2月15日19时至2月16日凌晨2时）`,
        kw4:`王阳英: 13006035757、文志刚: 15692591112（1月31日21时-24时）陈向芬: 13976658886、唐劲18208945660（2月1日凌晨0时-凌晨2时、早上6时至9时）霍娟: 13707522019、周经震: 13876699719（2月15日19时至2月16日凌晨2时）`,
        kw5:`林少雅: 18976673622、谭新锦18976568198 `,
        kw6:`陈海成: 17766981061、陈丽娟: 17766987687、林丽芳: 17766975813`,
        kw7:`吴诗健: 13976922536（1月31日21时至凌晨2时、2月15日21时至2月16日凌晨2时）吴泰杉: 13700478303（2月1日早上6时至9时）`,
        kw8:`陈浩钿: 13976985599 、冯定坤: 13647553122`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:`由秀英街道负责安排无人机全程监控`
					
    },
    {
        name:`永万路（海盛路以南）(及周边)`	,
        xyz:`110.265758,19.986023`,
        kw0:`秀英街道`,
        kw1:`罗伟: 17733154007`,
        kw2:`区商务局 吕启博: 15308983888`,
        kw3:`柯森林: 13111988261（1月31日21时-24时）林小瑜: 13337627577（2月1日凌晨0时-凌晨2时、早上6时至9时）杨德伟: 18789670203（2月15日19时至2月16日凌晨2时）`,
        kw4:`王阳英: 13006035757、文志刚: 15692591112（1月31日21时-24时）陈向芬: 13976658886、唐劲: 18208945660（2月1日凌晨0时-凌晨2时、早上6时至9时）霍娟: 13707522019、周经震: 13876699719（2月15日19时至2月16日凌晨2时）`,
        kw5:`黄光锋: 18976730878 郑永茂: 18976650138 `,
        kw6:`谭小喜: 13700494790 吴思华: 17766980835`,
        kw7:`吴诗健: 13976922536（1月31日21时至凌晨2时、2月15日21时至2月16日凌晨2时）、陈海霞: 13136038610（2月1日早上6时至9时）`,
        kw8:`许斌: 18789630000`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``
    },
    {
        name:`文明村(及周边)`	,
        xyz:`110.181385,19.971237`,
        kw0:`西秀镇`,
        kw1:`罗平: 13138966816`,
        kw2:`区审计局 黄茂蛟: 13005007971`,
        kw3:`肖就荣: 13322019990、胡炜彬15289816063、王晓颂13876311137`,
        kw4:`陈彰发: 18907532339、吴多勇15108997355、莫宗谊18889778038`,
        kw5:`李瑞琳: 13322006958、符会安: 15008042240、王康优: 13379880888、王康智: 13976676636、劳师明: 13322034178、吴勋滨: 13807503002、李白龙: 1337997980、李妹: 13876064942`,
        kw6:`王丽平: 18976918378`,
        kw7:`王尤锦: 13637666736、郑志光: 13807677170、吴坤旺: 18976567251、黄文学: 18889757871`,
        kw8:`民警 容裕文: 15109866669、联防 李光: 13976111727、吴坤昭: 18808927932`,
        kw9:`志愿者都被抽调至火车站疫情防控点，无法安排`,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``
					
    },
    {
        name:`宝龙城（及周边）`	,
        xyz:`110.185697,19.981166`,
        kw0:`西秀镇`,
        kw1:`凌立琼: 13976680822`,
        kw2:`区行政审批局 吴丹: 13698919854`,
        kw3:`肖就荣: 13322019990、胡炜彬: 15289816063、王晓颂: 13876311137`,
        kw4:`陈彰发: 18907532339、吴多勇: 15108997355、莫宗谊: 18889778038`,
        kw5:`李瑞琳: 13322006958、符会安: 15008042240、王康优: 13379880888、王康智: 13976676636、劳师明: 13322034178、吴勋滨: 13807503002、李白龙: 13379979806、李妹: 13876064942`,
        kw6:`王丽平: 18976918378`,
        kw7:`王尤锦: 13637666736、郑志光: 13807677170、吴坤旺: 18976567251、黄文学: 18889757871`,
        kw8:`民警 容裕文:15109866669、联防 李光: 13976111727、吴坤昭: 18808927932`,
        kw9:`志愿者都被抽调至火车站疫情防控点，无法安排`,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``		
    },
    {
        name:`火山口(及周边)`	,
        xyz:`110.22119,19.92762`,
        kw0:`石山镇`,
        kw1:`宁辉: 13700452990`,
        kw2:`区农业农村局 陈政: 13807655456`,
        kw3:`吴敏: 13698909672、陈大江: 13337564979`,
        kw4:`冯所民、陈学春、王运贵、吴小玲、李华燕、陈泰旭、吴至恭`,
        kw5:`洪义乾: 13337568899`,
        kw6:`王承山: 13976980930、王应武: 13876046249、陈冠贤: 13519847749、吕惠乾: 13518081889、王永仕: 13876177933、陈祖壮: 13518060880、陈光祥: 13807595099、吴清伟: 18976028264`,
        kw7:`王建诗: 18889792486`,
        kw8:`李献清: 18976396599`,
        kw9:`钟希: 18907567208符燕云: 18907562633`,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``		
    },
    {
        name:`观海台(及周边)`	,
        xyz:`110.250085,20.029478`,
        kw0:`海秀街道`,
        kw1:`李传家: 18089766266`,
        kw2:`区应急局 李经恒: 13876199977`,
        kw3:`蔡於军: 15607599577、钟茂: 18976007678`,
        kw4:`柯行伟: 18976536367、曾朝英: 13138913590`,
        kw5:`郑少娟: 13976653338`,
        kw6:`李雪转: 18808961591`,
        kw7:`陈勇: 13697569345、林诗军: 13807570331、王继岸: 15008924885`,
        kw8:`董文环: 13976739505、徐应勋: 18889285008`,
        kw9:`区应急局应急志愿者5名`,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``		
    },
    {
        name:`西秀海滩(及周边)`	,
        xyz:`110.259605,20.02029`,
        kw0:`海秀街道`,
        kw1:`郭逢喜: 18389768911`,
        kw2:`区旅文局 廖少曼: 13518915599`,
        kw3:`蔡於军: 15607599577、钟茂: 18976007678`,
        kw4:`柯行伟: 18976536367、曾朝英: 13138913590`,
        kw5:`郑少娟: 13976653338`,
        kw6:`杜宏作: 18689613297`,
        kw7:`陈勇: 13697569345  林诗军: 13807570331 王继岸: 15008924885`,
        kw8:`符策丽: 18976328070 、郑强敬: 18876605580`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``
    },
    {
        name:`永万路（海盛路以北） (及周边)`	,
        xyz:`110.265458,20.012518`,
        kw0:`海秀街道`,
        kw1:`翁伟: 13876329198`,
        kw2:`区人社局 周备鑫: 13976692398`,
        kw3:`陈紫虹13111993399、钟茂:18976007678`,
        kw4:`何儒波13278963635、黄标13036001250、王玲13337585931`,
        kw5:`余海鸿19907552062、王丽梅18976371599、郑伟强: 18976596708、王慧哲: 18889949992`,
        kw6:`王莉: 17766995792、吴丽娟: 17766995785、邢桂芳: 17766995790、郑华容: 18976596711、黄喜媛: 18876955097`,
        kw7:`刘扬全13627542691`,
        kw8:`符策丽18976328070 、郑强敬 18876605580`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``		
    },
    {
        name:`东山野生动植物园（及周边）`	,
        xyz:`110.246304,19.770361`,
        kw0:`东山镇`,
        kw1:`符源明: 18689890663`,
        kw2:`区退伍军人事务局 吴强: 13976011229`,
        kw3:`黎宏: 13698962208、符策武: 18689944626`,
        kw4:`何沂飞: 13627544510、周秀波13976630078、吴麒13307512405、林应裕13617599500、林银花13907647314、李菲菲15298982336`,
        kw5:`郑义秋13700423738、黄永诚13687596132`,
        kw6:`吴丹丹15109871249、陈 娆15120887290`,
        kw7:`李茂利18889555712、蔡英文18889839810、王纪伟13698957302、黄克高13637596074、林正锋15289729349`,
        kw8:`陈翔(民警)13887571207、邱荣标（所长）13337633166、符成（队长）13379879982`,
        kw9:``,
        kw10:`2022年1月31日21时至2月1日凌晨2时、2月1日早上6时至9时、2月15日21时至2月16日凌晨2时	`,
        kw11:``			
    }
  
]